import React from "react";
import {
  Grid,
  Button,

  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  withStyles
} from "@mui/styles";
import {getImage} from "../../../../../utils/image";
import clsx from "clsx";
import getTrans from "../../../../../languages/getTrans";

class DialogChangeCountry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      activeId: null,
      onSubmit: null,
    }
  }

  open = ({onSubmit}) => {
    this.setState({
      isOpen: true,
      onSubmit: onSubmit,
    })
  }
  close = () => {
    this.setState({
      isOpen: false,
    })
  }



  render() {
    const {classes,countries} = this.props;
    const {
      isOpen,
      activeId
    } = this.state;

    if (!isOpen) {
      return null
    }
    return (
      <Dialog
        open={isOpen}
        fullWidth={true}
        className={classes.root}
      >
        <DialogTitle>{getTrans('dialogChangeCountry.Выбор страны')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {countries.map((country) => (
              <Grid item xs={12}>
                <Button
                  fullWidth={true}
                  className={clsx({
                    [classes.country]: true,
                    '--active': Boolean(country.id === activeId),
                  })}
                  onClick={() => {
                    const {onSubmit} = this.state;
                    this.setState({activeId: country.id});
                    // Отказываемся от отдельного подтверждения: сразу применяем выбор.
                    if (typeof onSubmit === "function") {
                      onSubmit(country.id);
                    }
                  }}
                >
                  <div className={classes.countryIcon}>
                    <img src={getImage(country.icon_id)}/>
                  </div>
                  <div className={classes.countryName}>{country?.name}</div>
                </Button>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Button
                fullWidth={true}
                variant="contained"
                onClick={this.close}
              >{getTrans('common.Закрыть')}</Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    )
  }
}

const styles = {
  root: {
    "& .MuiPaper-root": {
      margin: 0,
      width: "100%",
      maxHeight: "80%",
      backgroundColor: "#0F191F",
      borderRadius: "16px 16px 0 0"
    },
    "& .MuiDialogTitle-root": {
      padding: "12px 20px",
      fontSize: "22px",
      lineHeight: "26px",
    },
    "& .MuiDialogContent-root": {
      padding: "0px 20px",
    },
    "& .MuiDialogActions-root": {
      padding: "12px 20px",
      "& .MuiButton-contained": {
        height: 40,
        fontSize: "16px",
      }
    },
    "& .MuiDialog-container": {
      alignItems: "flex-end",
      justifyContent: "initial",
    }
  },

  country: {
    height: 44,
    padding: "6px",
    borderRadius: "6px",
    boxSizing: "border-box",
    justifyContent: "flex-start",
    border: "1px solid #24323A",
    backgroundColor: "#24323A!important",

    "&.--active": {
      borderColor: "#FB7800!important",
    }
  },
  countryIcon: {
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    position: "relative",
    borderRadius: "100%",
    justifyContent: "center",
    width: 32, height: 32, marginRight: 10,
    "& img": {
      position: "relative",
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "50% 50%",
    }
  },
  countryName: {
    fontSize: 16,
    color: "#E7E6E6",
    fontWeight: "500",
    lineHeight: "20px",
  },
};
DialogChangeCountry = withStyles(styles)(DialogChangeCountry);
export default DialogChangeCountry
